export default class BaseApi {
  baseUrl = "";

  constructor(url) {
    this.baseUrl = "/api/" + url;
  }

  _sanitize(id) {
    if (id && (id.includes?.("://") || id.startsWith?.("//"))) {
      throw new Error("Invalid ID format");
    }
    return id;
  }

  index(params = null) {
    return axios.get(this.baseUrl, { params });
  }

  show(id, params = null) {
    const sanitizedId = this._sanitize(id);
    return axios.get(`${this.baseUrl}/${sanitizedId}`, { params });
  }

  create(data) {
    return axios.post(this.baseUrl, data);
  }

  createWithFiles(formData) {
    return axios.post(`${this.baseUrl}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  update(id, data) {
    const sanitizedId = this._sanitize(id);
    return axios.put(`${this.baseUrl}/${sanitizedId}`, data);
  }

  updateWithFiles(id, formData) {
    const sanitizedId = this._sanitize(id);
    const method = formData.get("_method") || "PUT";
    return axios.post(
      `${this.baseUrl}/${sanitizedId}?_method=${method}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  }

  destroy(id, params = null) {
    const sanitizedId = this._sanitize(id);
    return axios.delete(`${this.baseUrl}/${sanitizedId}`, { params });
  }
}
